var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.$store.state.stocks.stocks},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{
          name: 'Editare stoc',
          params: { productId: _vm.$route.params.productId, stockId: item.id },
        }}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("edit")])],1),_c('v-icon',{on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v("delete")])]}}],null,true)}),_c('v-layout',{attrs:{"justify-center":""}},[_c('router-link',{attrs:{"to":{
        name: 'Adaugare stoc',
        params: { productId: _vm.$route.params.productId },
      }}},[_c('v-btn',{attrs:{"color":"red","fab":"","small":"","dark":"","fixed":"","bottom":"","justify-center":""}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }